export default __webpack_public_path__ + "static/media/2.68fba92a.JPG";